<section >
  <div class="title mb-4">
    <h2>Manage Roles</h2>
    <p style="font-size: 0.6rem;"><q>Role use to Control Ui element Permission ( View / Edit / delete )</q></p>
  </div>

  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link" [ngClass]="{'active':selMenu=='roles'}" (click)="selectMenu('roles')">Roles</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [ngClass]="{'active':selMenu=='assignToLevel'}" (click)="selectMenu('assignToLevel')">Assign
       Role To Level</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [ngClass]="{'active':selMenu=='assignToCharacter'}" (click)="selectMenu('assignToCharacter')">Assign
       Role To Profile Character</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [ngClass]="{'active':selMenu=='assignLevelToRole'}" (click)="selectMenu('assignLevelToRole')">Assign
       Level Range To role</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [ngClass]="{'active':selMenu=='assignToUsers'}" (click)="selectMenu('assignToUsers')">Assign
        Role Type To Users</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [ngClass]="{'active':selMenu=='manageRoleType'}" (click)="selectMenu('manageRoleType')">Manage Role Type</a>
    </li> 
   
  </ul>

  <!-- Body -->
  <section [ngStyle]="{'display': selMenu=='roles' ? 'block' :'none' }" class="mt-3">
    <section class="d-flex justify-content-between" style="gap: 5px;">
      <button type="submit" class="btn btn-dark mb-2" (click)="addRole(AddRole)"><i aria-hidden="true"
          class="fa fa-plus-circle"></i> Create New Role</button>
      <div>
        <button type="submit" class="btn btn-dark mb-2" (click)="addRolePermissions(AddPermissions)"><i
            aria-hidden="true" class="fa fa-plus-circle"></i> Manage Permissions (Add/Delete)</button>
      </div>
    </section>
    <table class="table table-hover white_box shadow">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">Role Name</th>
          <th scope="col">Description</th>
          <th scope="col">Assign Permissions To Role</th>
          <th scope="col">Status</th>
          <th scope="col" class="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of roleList; let i = index;">
          <th scope="row">{{i + 1}}</th>
          <td><span class="sub-cate">{{item?.roleName | uppercase}}</span></td>
          <td>{{item?.description}}</td>
          <td width="500">
            <div class="d-flex" style="max-width: 35rem;">
              <select class="form-control" (change)="onPermissionChange($event.target.value)">
                <option value="">Add Permission For Role</option>
                <option [value]="r.permissionsID" *ngFor="let r of (rolePermissionsList || [])"> {{r?.permissionsName}}
                </option>
              </select>
              <span class="px-2 d-flex justify-content-center" style="align-items: center;">
                <i class="fa fa-plus-circle"
                  (click)="addMemberRolePermissionsRelationship(item.roleId,(item?.rolePermissions || []))"
                  title="Add Permission Type" aria-hidden="true" style="font-size: 1.5rem;"></i>
                <!-- <i class="fa fa-trash pl-2" (click)="deleteMemberRolePermissions(i)"
                                    title="Delete Permission Type" aria-hidden="true" style="font-size: 1.5rem;"></i> -->
              </span>
            </div>
            <section class=" mt-2 mx-1" style="max-width: 35rem;">
              <span class="sub-cate m-1" *ngFor="let j of (item?.rolePermissions || [])">{{j?.permissionsName}} <i
                  class="fa fa-times" aria-hidden="true"
                  (click)="deleteMemberRolePermissionsRelationship(j.rolePermissionID)"></i></span>
            </section>
          </td>
          <td>{{item?.status?"Active":'Disabled'}}</td>
          <td class="text-right">
            <section class="d-flex justify-content-center" style="gap: 5px;">
              <button class="btn btn-dark" (click)="addRole(AddRole,item)"><i class="fa fa-pencil"
                  aria-hidden="true"></i> Edit</button>
              <button class="btn btn-danger" (click)="deleteRole(item?.roleId)"><i class="fa fa-trash"
                  aria-hidden="true"></i> Delete</button>
            </section>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
  <section *ngIf="selMenu=='assignToLevel'" class="mt-3">
    <app-assign-to-level></app-assign-to-level>
  </section>
  <section *ngIf="selMenu=='assignToCharacter'" class="mt-3">
    <app-assign-to-character></app-assign-to-character>
  </section>
  <section *ngIf="selMenu=='assignToLevel'" class="mt-3">
    <app-assign-to-level [selMenu]="'userType'"></app-assign-to-level>
  </section>
  <section *ngIf="selMenu=='assignLevelToRole'" class="mt-3">
    <app-assign-to-level [selMenu]="'roles'"></app-assign-to-level>
  </section>

  
  <section *ngIf="selMenu=='assignToUsers'" class="mt-3">
    <assign-to-users></assign-to-users>
  </section>
  <section *ngIf="selMenu=='manageRoleType'" class="mt-3">
    <assign-to-users [selMenu]="'userType'"></assign-to-users>
  </section>
  <!-- Body -->
</section>

<ng-template #AddRole let-modal>
  <div class="modal-body">
    <div class="add_cattt d-flex justify-content-between">
      <h2>Add Role</h2>
      <img loading="lazy" src="../../../assets/images/close-icon.svg" alt="img" (click)="modal.dismiss('Cross click')" />
    </div>
    <div class="referral-link">
      <section class="m-4">
        <div class="form-group">
          <input type="text" class="form-control" placeholder="Enter Role Name" maxlength="500"
            [(ngModel)]="formRoleName" />
        </div>

        <div class="form-group">
          <input type="text" class="form-control" placeholder="Enter Role Description" maxlength="500"
            [(ngModel)]="formRoleNameDescription" />
        </div>
      </section>
      <div class="mt-4">
        <div class="cart_btn">
          <button class="com_btn add-review-btn px-2" (click)="AddRoleSubmit()">Save <i class="fa fa-save"
              aria-hidden="true"></i></button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #AddPermissions let-modal>
  <div class="modal-body">
    <div class="add_cattt d-flex justify-content-between">
      <h2>Manage Role Permissions</h2>
      <img loading="lazy" src="../../../assets/images/close-icon.svg" alt="img" (click)="modal.dismiss('Cross click')" />
    </div>
    <div class="referral-link">
      <section class="m-4">
        <div class="row">
          <span class="sub-cate m-1" *ngFor="let j of (rolePermissionsList || [])">{{j?.permissionsName}} <i
              class="fa fa-times" aria-hidden="true" (click)="deleteMemberRolePermissions(j.permissionsID)"></i></span>
        </div>
        <p class="text-center mt-5 mb-2"><i aria-hidden="true" class="fa fa-plus-circle"></i>Add New Permission</p>
        <div class="form-group">
          <input type="text" class="form-control" placeholder="Enter Permissions Name" maxlength="500"
            [(ngModel)]="formRolePermissionsName" />
        </div>

        <div class="form-group">
          <input type="text" class="form-control" placeholder="Enter Permissions Description" maxlength="500"
            [(ngModel)]="formRoleNamePermissionsDescription" />
        </div>
      </section>
      <div class="mt-4">
        <div class="cart_btn">
          <button class="com_btn add-review-btn px-2" (click)="AddRolePermissionsSubmit()">Save <i class="fa fa-save"
              aria-hidden="true"></i></button>
        </div>
      </div>
    </div>
  </div>
</ng-template>